class TextInput extends HTMLElement {
  constructor() {
    super();
    this.type = this.getAttribute("data-type");
    let showPw = this.querySelector("#show_pw");
    let inputPw = this.querySelector('input[type="password"]');

    if (this.type == "password")
      showPw.addEventListener("click", () => {
        if (showPw.checked) {
          inputPw.type = "text";
        } else {
          inputPw.type = "password";
        }
      });
  }
}
customElements.define("text-input", TextInput);
